import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ['setter', 'input']

  update(event) {
    let value = this.setterTarget.value
    let template = this.data.get('template')
    let name = template.replace(/{{.*value.*}}/g, value)

    this.inputTarget.setAttribute('name', name)
    this.inputTarget.setAttribute('id', name)
  }
}
